/**
 * HOOK: useSchools (VERSION REFACTORISÉE)
 * Utilise le hook useCRUD générique
 *
 * 🎯 Avant: 130 lignes | Après: 22 lignes | Réduction: 83%
 */

import type { School, CreateSchoolDto, UpdateSchoolDto } from '../types/school';
import { useCRUD } from './useCRUD';

export function useSchools() {
  const crud = useCRUD<School, CreateSchoolDto, UpdateSchoolDto>('schools', {
    select: '*, contacts:contacts!school_id(count)',
    orderBy: { column: 'name', ascending: true },
  });

  return {
    // API spécifique (pour compatibilité)
    schools: crud.data,
    loading: crud.loading,
    error: crud.error,
    refreshSchools: crud.refresh,
    getSchoolById: crud.getById,
    createSchool: crud.create,
    updateSchool: crud.update,
    deleteSchool: crud.remove,
    deleteSchools: crud.removeMany,

    // API générique (pour useEntityList)
    data: crud.data,
    create: crud.create,
    update: crud.update,
    remove: crud.remove,
    removeMany: crud.removeMany,
  };
}

/**
 * MIGRATION GUIDE:
 *
 * ✅ API 100% COMPATIBLE - Aucun changement nécessaire dans les composants !
 *
 * Le hook expose exactement les mêmes méthodes que l'ancienne version:
 * - schools, loading, error
 * - fetchSchools(), createSchool(), updateSchool(), deleteSchool()
 */
